import { Grid, Tab, Tabs } from "@mui/material";
import React from "react";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { EE123SalariesRole_Edit, EE123SalariesRole_View } from "../../../Component/Common/Constants/UserRoles";
import { EEScorecardAtom } from "../../../State/EEScorecard.Atom";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { userRolesState } from "../../../State/user.Atom";
import { EmployeeSalariesTableWithActions } from "./EmployeeSalaries/EmployeeSalariesTableWithActions";
import { EmployeeStructureTableWithActions } from "./EmployeeStructureTableWithActions";
import config from "../../../config";
import { EmployeeSalariesTableWithActions_Old } from "./EmployeeSalaries/Old/EmployeeSalariesTableWithActionsOld";



export const EmployeeStructureBasePage = () => {

    const scorecard = useRecoilValue(ScorecardAtom);
    const scorecardDto = useRecoilValue(EEScorecardAtom);
    const [filterDate, setFilterDate] = React.useState<Date>(new Date(scorecardDto.ReportPeriodDateTo));
    const filterByDate = false;

    const routes = [
        "/ee/scorecard/" + scorecard.scorecardId + "/structure",
        "/ee/scorecard/" + scorecard.scorecardId + "/salaries",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;

    const restrictedUsers = [
        EE123SalariesRole_Edit,
        EE123SalariesRole_View
    ];

    const userRoles = useRecoilValue(userRolesState);

    return (
        <>
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    Employee Structure
                </MDTypography>
            </MDBox>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Employee Structure" value={routes[0]} to={routes[0]} component={Link} />
                        {userRoles.some(r => restrictedUsers.includes(r)) && <Tab label="Employee Salaries" value={routes[1]} to={routes[1]} component={Link} />}
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={2}>
                    <Switch>
                        <Route path={routes[0]}>
                            <EmployeeStructureTableWithActions
                                scorecardId={scorecard.scorecardId}
                                filterByDate={filterByDate}
                                scorecard={scorecardDto}
                                hasFilters={true}
                            />
                        </Route>
                        {config.enable_employment_equity_salary === 'true' ?
                            <Route path={routes[1]}>
                                <EmployeeSalariesTableWithActions
                                    scorecardId={scorecard.scorecardId}
                                    hasFilters={true}
                                    employedAtDate={filterDate}
                                />
                            </Route>
                            :
                            <Route path={routes[1]}>
                                <EmployeeSalariesTableWithActions_Old
                                    scorecardId={scorecard.scorecardId}
                                    scorecard={scorecardDto}
                                    hasFilters={true}
                                    filterByDate={filterByDate}
                                    filterDate={filterDate} />
                            </Route>
                        }

                    </Switch>
                </Grid>
            </Grid>
        </>);
}